import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactImageMagnify from "react-image-magnify";
import defaultImage from "./../../images/img1.png";
import droupdown from "./../../images/down-arrow.png";
import { useParams } from "react-router-dom";
import Mainlayout from "../../components/Mainlayout";
import { FaChevronLeft, FaChevronRight, FaShoppingCart } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { useCart } from "../../store/CartContext";
// import latestproduct from './../../data/latestproduct.json';
import RelatedProduct from "../../components/relatedproducts/RelatedProduct";
import styled from "styled-components";
import { Canvas } from "@react-three/fiber";
import { Suspense } from "react";
import { useLoader } from "@react-three/fiber";
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { OrbitControls } from "@react-three/drei";
import { Modal, MenuItem } from "@mui/material";
import AppBreadcrumbs from "../../components/breadcrumbs/AppBreadcrumbs";
import { Box, TextField, Button, FormControl, InputLabel } from "@mui/material";
// import { Typography } from '@mui/material';
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import MyButton from "../../components/button/MyButton";
import MySelect from "../../components/select/MySelect";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import RetryableImage from "../../components/retryableImage/RetryableImage";
import MyButtonGroup from "../../components/button/MyButtonGroup";
import { Tabs, Tab } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";


// Define TableSection as a styled div
const DocumentationSection = styled.div`
  margin-top: 40px;

  @media (max-width: 768px) {
    margin-top: 30px;
  }
`;

const TableWrapper = styled.div`
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;

  @media (max-width: 768px) {
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
`;

const DataTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const DataRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }
`;

const DataCell = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
`;

const HeaderCell = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  border-top: 2px solid #ccc;
`;
const ProductDetailsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const Imagespace = styled.div`
  border: ${window.ENV.GENERAL.PRODUCTDETAIL_IMAGE_BOARDER};
  border-radius: 10px;
  position: relative;
  max-width: 100%;
  
  margin: 0 auto;


  .react-image-magnify__container {
    border-radius: 10px;
    width: 100%;
    height: auto;
    position: relative;
  }

  .react-image-magnify__image {
    border-radius: 10px;
    width: 100%;
    height: auto;
    display: block;
  }

  @media (max-width: 768px) {
    max-width: 320px;
    margin: 0 auto;

    .react-image-magnify__container {
      max-height: 320px;
    }

    .react-image-magnify__image {
      max-height: 300px;
      object-fit: contain;
    }
  }
`;

const ImageColumn = styled.div`
  width: 400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 320px;
  }
`;

const ErrorMessage = styled.div`
  color: red;
  text-align: center;
`;

const DetailsWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const ImageSection = styled.div`
  flex: 1;
  max-width: 50%;
  text-align: center;
  border-radius: 10px;

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
`;

const Thumbnails = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  margin-top: 10px;
  justify-content: flex-start;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 6px;
  }
`;

const Thumbnail = styled.img`
  width: 72px;
  height: 72px;
  cursor: pointer;
  border: ${window.ENV.GENERAL.PRODUCTDETAIL_IMAGE_BOARDER};
  border-radius: 10px;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: window.ENV.GENERAL.BACKGROUND_COLOR;
  }

  @media (max-width: 768px) {
    width: 70px;
    height: 70px;
  }
`;

const InfoSection = styled.div`
  flex: 1;
  max-width: 60%;
  min-width: 600px;
  margin-left: 100px;
  margin-top: 0px;

  @media (max-width: 1024px) {
    min-width: auto;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    margin-left: 0;
  }
`;

const Heading = styled.h2`
  font-size: 34px;
  margin-bottom: 15px;
  font-weight: bold;
  margin-top: 0px;
  color: #003063;
  font-weight: 500;
  font-family: ${window.ENV.FONT_FAMILY || 'UP-Book, sans-serif'};
  width:100%;
  @media (max-width: 768px) {
    font-size: 30px;
    margin-left: 0;
  }
`;
const Headings = styled.h2`
  font-size: 24px;
  margin-bottom: 10px;
  font-weight: bold;
  margin-left: 7px;
  padding-top: 5px;
  color: #003063;
  font-weight: 500;
  font-family: "UP-Book", sans-serif;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  h4 {
    margin-top: 10px;
    margin-bottom: 3px;
  }
`;

const StyledRow = styled.tr`
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  margin-top: 8px;
`;

const StyledCell = styled.td`
  padding: 8px 1px;
  vertical-align: top;
  border: none;
  width: ${(props) => (props.first ? "60%" : "65%")};
  font-weight: ${(props) => (props.first ? "bold" : "normal")};
  text-align: ${(props) => ("left")};
  font-size: 16px;
`;

const ButtonSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 50px;
  gap: 20px;
  /* margin-left: ${window.ENV.PRODUCT_DETAILS_BUTTON_SECTION_MARGIN_LEFT || "50px"}; */

  @media (max-width: 768px) {
    margin-left: 0;
    justify-content: center;
    gap: 15px;
    margin-top: 30px;
  }
`;

const ButtonDetails = styled.button`
  padding: 10px 15px;
  font-size: 18px;
  border: 1px solid #f2f1f6;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${window.ENV.BUTTON.BACKGROUND_COLOR};
  color: ${window.ENV.BUTTON.TEXT_COLOR};
  &:hover {
    background-color: ${window.ENV.BUTTON.HOVER_BACKGROUND_COLOR};
    color: ${window.ENV.BUTTON.HOVER_TEXT_COLOR};
  }
`;

const Select = styled.select`
  margin-top: 16px;
  font-weight: 500;
  font-size: 0.975rem;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  padding: 6px 16px;
  // font-size: 18px;
  border: 1px solid ${window.ENV.GENERAL.TEXT_COLOR};
  border-radius: 2px;
  cursor: pointer;
  width: 240px;
  color: ${window.ENV.GENERAL.TEXT_COLOR};
  background-color: ${window.ENV.GENERAL.BACKGROUND_COLOR};
  // background-image: url("/src/images/down-arrow.png");
  // background-repeat: no-repeat;
  // background-position: right 7px center;
  // background-size: 30px 30px;
  &:hover {
    // background-color: ${window.ENV.GENERAL.BACKGROUND_COLOR};
    //  color: ${window.ENV.GENERAL.TEXT_COLOR};
  }
`;

const BrochureButton = styled(ButtonDetails)`
  background-color: ${window.ENV.BUTTON.BACKGROUND_COLOR} !important;
  color: ${window.ENV.BUTTON.TEXT_COLOR} !important;
  border: 1px solid #ddd !important;
  &:hover {
    background-color: ${window.ENV.BUTTON.HOVER_BACKGROUND_COLOR} !important;
    color: ${window.ENV.BUTTON.HOVER_TEXT_COLOR} !important;
  }
`;

const Productdetailhr = styled.hr`
  border: 0px;
  border-top: 1px solid #e1e1e1;
  margin-top: 40px;
  margin-bottom: 0px;
`;

const ModalBoxStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  fontFamily: window.ENV.FONT_FAMILY || 'UP-Book, sans-serif',
  padding: "20px !important",
  width: "40%",
  "@media (max-width: 768px)": {
    width: "90%",
    padding: "15px !important",
  },
};

const ModalDownloadBoxStyles = {
  ...ModalBoxStyles,
  "@media (max-width: 768px)": {
    width: "90%",
    padding: "15px !important",
  },
};

// Add DescriptionSection styled component OUTSIDE the Productdetails component
const DescriptionSection = styled.div`
  margin-top: 40px;
  @media (max-width: 768px) {
    margin-top: 30px;
  }
`;

const companyName = window.ENV.EMAIL.SENDER_NAME;
const headerColor = window.ENV.EMAIL.HEADER_COLOR;
const year = new Date().getFullYear();
const mainWidth = '700px';
const borderRadius = '8px';
const borderColor = '#eee';
const footerColor = '#2196f3';
const headerFontSize = '2em';
const headerPadding = '36px 0';
const boxPadding = '32px 24px';
const boxMargin = '30px auto 0 auto';
const boxBg = '#ffffff';
const footerPadding = '18px 0';

const RFQAcknowledgmentHtml = `
  <!DOCTYPE html>
  <html>
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <title>${companyName} Acknowledgment</title>
  </head>
  <body style="margin:0; padding:0; background:#ffffff;">
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#ffffff;">
      <tr>
        <td align="center">
          <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width:700px; min-width:320px; background:#ffffff; margin:40px auto 0 auto; border-radius:8px; border:1px solid #eee;">
            <tr>
              <td align="center" bgcolor="${headerColor}" style="padding:36px 0; border-radius:8px 8px 0 0;">
                <span style="font-size:2em; font-weight:bold; color:#fff; font-family:Arial,sans-serif;">${companyName}</span>
              </td>
            </tr>
            <tr>
              <td align="left" style="padding:32px 24px; background:#ffffff;">
                <div style="font-size:1.1em; color:#222; margin-bottom:18px; font-family:Arial,sans-serif;">
                  Welcome to ${companyName}!
                </div>
                <div style="font-size:1.15em; color:#222; font-weight:bold; margin-bottom:18px; font-family:Arial,sans-serif;">
                  Thank you for choosing ${companyName}.<br>
                  A sales representative will be contacting you shortly on your request.
                </div>
                <div style="font-size:1em; color:#444; font-family:Arial,sans-serif;">
                  Best Regards,<br>
                  The ${companyName} Team
                </div>
              </td>
            </tr>
            <tr>
              <td align="center" style="padding:18px 0; color:${footerColor}; font-size:1em; background:#fff; border-radius:0 0 8px 8px; font-family:Arial,sans-serif;">
                ${companyName} &copy; ${year}
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
  </html>
`;

const downloadAcknowledgmentHtml = `
  <!DOCTYPE html>
  <html>
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <title>${companyName} Download Acknowledgment</title>
  </head>
  <body style="margin:0; padding:0; background:#ffffff;">
    <table width="100%" cellpadding="10" cellspacing="10" border="0" style="background:#ffffff;">
      <tr>
        <td align="center">
          <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width:700px; min-width:320px; background:#ffffff; margin:40px auto 0 auto; border-radius:8px; border:1px solid #eee;">
            <tr>
              <td align="center" bgcolor="${headerColor}" style="padding:36px 0; border-radius:8px 8px 0 0;">
                <span style="font-size:25px; font-weight:bold; color:#fff; font-family:Arial,sans-serif;">${companyName}</span>
              </td>
            </tr>
            <tr>
              <td align="left" style="padding:32px 24px; background:#ffffff;">

                <div style="font-size:1.15em; color:#222; font-weight:bold; margin-bottom:18px; font-family:Arial,sans-serif;">
                  Thank you for downloading from our 3D Product Catalog!<br>
                  
                </div>
                <div style="font-size:1em; color:#444; font-family:Arial,sans-serif;">
                  Best Regards,<br>
                  ${companyName}
                </div>
              </td>
            </tr>
            <tr>
              <td align="center" style="padding:18px 0; color:${footerColor}; font-size:1em; background:#fff; border-radius:0 0 8px 8px; font-family:Arial,sans-serif;">
                ${companyName} &copy; ${year}
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
  </html>
`;

const Productdetails = () => {
  const { categoryName, itemName } = useParams();
  const productUrl = window.location.href;
  const [productData, setProductData] = useState(null);
  const [currentImage, setCurrentImage] = useState();
  const [error, setError] = useState(null);
  const [latestproduct, setLatestproduct] = useState([]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [modelPath, setModelPath] = useState("");

  const totalItems = latestproduct.length; // Total number of items
  const itemsPerSlide = window.ENV.RELATED_PRODUCT_TOTAL_COUNT; // Number of items per slide
  const [selectedOption, setSelectedOption] = useState("1");

  const [docNamesArray, setDocNamesArray] = useState([]);
  const [docValuesArray, setDocValuesArray] = useState([]);
  const [docValueText, setDocValueText] = useState([]);
  const [selectedUrl, setSelectedUrl] = useState(""); // State to store the selected value
  console.log("productData", productData);

  // <option value=""></option>
  // <option value={productData["2D_Drawing"]}>
  //   2D Drawing (.pdf)
  // </option>
  // <option value={productData["3D_PDF"]}>3D Drawing (.pdf)</option>
  // <option value={productData["Creo_Parametric"]}>
  //   Creo_Parametric (.asm)
  // </option>
  // <option value={productData["SolidWorks_Format"]}>
  //   SolidWorks_Format (.sldprt)
  // </option>
  // <option value={productData["STEP"]}>STEP (.stp)</option>
  // <option value={productData["ACIS_Format"]}>
  //   ACIS_Format (.sat)
  // </option>
  // <option value={productData["Parasolid_Format"]}>
  //   Parasolid_Format (.x_t)
  // </option>
  // <option value={productData["IGES"]}>IGES (.igs)</option>

  let downloadFiles = [];

  // Next slide handler
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalItems);
  };

  // Previous slide handler
  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + totalItems) % totalItems);
  };

  // Calculate visible items for the current slide
  const relatedItems = Array.from({ length: itemsPerSlide }, (_, i) => {
    const index = (currentIndex + i) % totalItems; // Generate item numbers
    return latestproduct[index];
  });

  const [openModal, setOpenModal] = useState(false);
  const [openModalDownload, setOpenModalDownload] = useState(false);
  const initialFormState = {
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    comments: "",
  };
  const [formValues, setFormValues] = useState(initialFormState);
  const { addToCart, isInCart } = useCart();

  const resetForm = () => {
    setFormValues(initialFormState);
  };
  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const handleModalClose = () => {
    resetForm();
    setOpenModal(false);
  };

  const handleModalOpenDownload = () => {
    setOpenModalDownload(true);
  };

  const handleModalCloseDownload = () => {
    resetForm();
    setOpenModalDownload(false);
  };

  // Add to cart functionality
  const handleAddToCart = () => {
    if (!productData) return;

    const cartItem = {
      productId: productData.productId,
      productName: productData.productName || productData.productId,
      categoryName: categoryName || 'Unknown Category',
      imageUrl: productData.isometric_view || productData.front_view || productData.side_view || productData.top_view || productData.drw_image || '',
    };

    console.log('Cart Item:', cartItem);
    console.log('Available image fields:', {
      isometric_view: productData.isometric_view,
      front_view: productData.front_view,
      side_view: productData.side_view,
      top_view: productData.top_view,
      drw_image: productData.drw_image
    });
    const result = addToCart(cartItem);
    showSnackbar(result.message, result.success ? 'success' : 'info');
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Snackbar state
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [pendingDownload, setPendingDownload] = useState(null); // { formValues, selectedOption }
  const showSnackbar = (message, severity = 'info') => {
    setSnackbar({ open: true, message, severity });
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar({ ...snackbar, open: false });
    // Removed download trigger from here
  };

  const handleFormSubmitDownload = async () => {
    // Validate that all required fields are filled
    const {
      firstName,
      lastName,
      email,
      contactNumber,
      address,
      city,
      state,
      zipCode,
      comments,
    } = formValues;
    const requiredFields = window.ENV.DOWNLOAD_MANDATORY_COLUMNS;
    const missingFields = requiredFields.filter(field => !formValues[field] || formValues[field].trim() === "");
    if (missingFields.length > 0) {
      showSnackbar("Please fill all required fields: " + missingFields.join(", "), 'error');
      return;
    }

    // Only allow PDF download

    // const fileExtension = selectedOption?.split(".").pop().toLowerCase();
    // if (fileExtension !== "pdf") {
    //   showSnackbar("Only PDF download is allowed after form submit.", 'error');
    //   return;
    // }

    // Show success snackbar and close modal, then process download/email after 1 second
    showSnackbar("Form Submitted Successfully!", 'success');
    setOpenModalDownload(false);
    setPendingDownload({ formValues: { ...formValues }, selectedOption });
    resetForm();

    // Trigger download after 1 second
    setTimeout(() => {
      processDownloadAndEmail({ ...formValues }, selectedOption);
      setPendingDownload(null);
    }, 1000);
  };

  const handleFormSubmit = async () => {
    // Validate that all required fields are filled
    const {
      firstName,
      lastName,
      email,
      contactNumber,
      address,
      city,
      state,
      zipCode,
      comments,
    } = formValues;
    const requiredFields = window.ENV.RFQ_MANDATORY_COLUMNS;
    const missingFields = requiredFields.filter(field => !formValues[field] || formValues[field].trim() === "");
    if (missingFields.length > 0) {
      showSnackbarRFQ("Please fill all required fields: " + missingFields.join(", "), 'error');
      return;
    }
    // Show success snackbar and close modal, then process RFQ/email after snackbar closes
    showSnackbarRFQ("Form Submitted Successfully!", 'success');
    setOpenModal(false);
    setPendingRFQ({ formValues: { ...formValues } });
    resetForm();
  };

  const dataKey = window.ENV.GOOGLE_SHEET_ID;
  const API_URL = process.env.REACT_APP_API_URL;
  const url = `${API_URL}/${window.ENV.TENANT_NAME}/${window.ENV.DATA_SOURCE}/data`;
  const requestBody = {
    range: "Product!A1:" + window.ENV.TOTAL_PRODUCTS,
    dataKey: dataKey,
    filters: {
      productId: [itemName],
    },
  };

  useEffect(() => {
    axios
      .post(url, requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data && Array.isArray(response.data)) {
          setProductData(response.data[0]); // Assuming the first product is displayed
          console.log(productData);

          // Fetch related product IDs
          const relatedProductIds =
            response.data[0]?.relatedProduct?.split(","); // Assuming the related products are a comma-separated string of IDs

          if (relatedProductIds && relatedProductIds.length > 0) {
            const requestBodys = {
              range: "Product!A1:" + window.ENV.TOTAL_PRODUCTS,
              dataKey: dataKey,
              filters: {
                productId: relatedProductIds,
              },
            };

            axios
              .post(url, requestBodys, {
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                if (response.data && Array.isArray(response.data)) {
                  // Set the related products in the relatedItems state
                  console.log(response.data);
                  setLatestproduct(response.data); // Store related products in relatedItems state
                }
              })
              .catch((error) => {
                const errorMessage = error.response
                  ? error.response.data.message
                  : error.message;
                setError(
                  errorMessage || "An error occurred while fetching the data."
                );
              });
          }
        }
      })
      .catch((error) => {
        const errorMessage = error.response
          ? error.response.data.message
          : error.message;
        setError(errorMessage || "An error occurred while fetching the data.");
      });
  }, [itemName]);

  function extractFilenameWithExtension(url) {
    // Ensure the URL is a string and not empty
    if (typeof url === "string" && url.trim() !== "") {
      // Split the URL by '/' and get the last segment
      const segments = url.split("/");
      const filenameWithExtension = segments[segments.length - 1];
      return filenameWithExtension;
    } else {
      console.error("Invalid URL provided.");
      return null;
    }
  }

  useEffect(() => {
    if (productData && productData.docName && productData.docValue) {
      setDocNamesArray(productData.docName.split(","));

      const filenamesWithExtension = productData.docValue
        .split(",")
        .map((url) => extractFilenameWithExtension(url));

      setDocValueText(filenamesWithExtension);

      setDocValuesArray(productData.docValue.split(",")); // setDocValuesArray(filenamesWithExtension)

    } else {
      console.error("productData is missing or incomplete.");
      setDocNamesArray([]);
      setDocValuesArray([]);
      setDocValueText([]);
    }
  }, [productData]);

  console.log("docvalueArray", docValuesArray);


  const handleDownloadModalOpen = (fileUrl) => {
    handleModalOpenDownload();
  };

  const handleFileAction = (fileUrl) => {
    if (!fileUrl || fileUrl === "1") {
      console.log("No file URL available.");
      return;
    }

    const fileExtension = fileUrl.split(".").pop().toLowerCase();
    const fileName = fileUrl.split("/").pop();

    console.log("fileUrl:", fileUrl);
    console.log("fileExtension:", fileExtension);

    if (fileExtension === "pdf") {
      console.log(".pdf file:", fileExtension);
      // Open PDF in new tab
      window.open(fileUrl, "_blank");
    } else if (fileExtension === "obj" || fileExtension === "zip" || fileExtension === "mp4") {
      // Open 3D model in modal
      setModelPath(fileUrl);
      setOpen(true);
    } else {
      // Force download for other file types
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName || "file");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };


  const handleActions = (modelPath) => {
    if (modelPath) {
      console.log("3D Model URL: ", modelPath); // Log the URL
      setModelPath(modelPath); // Set the model path for loading
      setOpen(true); // Open the modal
    } else {
      console.error("3D Model path is invalid or not available.");
    }
  };

  const handleClose = () => {
    setOpen(false);
    setModelPath(""); // Clear the model path on close
  };

  const OBJModel = ({ modelPath }) => {
    const [error, setError] = useState(false);

    // Load the .obj model using the OBJLoader
    const obj = useLoader(OBJLoader, modelPath, (loader) => {
      loader.manager.onError = (url) => {
        console.error(`Error loading model from ${url}`);
        setError(true); // Set error state if loading fails
      };
    });

    if (error) {
      return <p>Error loading 3D model. Please try again later.</p>;
    }

    if (!obj) {
      return <p>Loading 3D model...</p>;
    }

    return <primitive object={obj} scale={1} />;
  };
  const viewTypes = ["isometric_view", "front_view", "side_view", "top_view", "drw_image"];

  useEffect(() => {
    if (productData && productData[viewTypes[0]]) {
      setCurrentImage(`${window.ENV.SERVER_URL}${productData[viewTypes[0]]}`);
    }
  }, [productData]);

  const handleSortOnChange = (selectedOption1) => {
    console.log("Selected File URL:", selectedOption1); // Debugging log
  };

  // Add state for tab selection
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  console.log("selectedOption", selectedOption);

  // This function is called after the snackbar closes
  const processDownloadAndEmail = async (formValues, selectedOption) => {
    const {
      firstName,
      lastName,
      email,
      contactNumber,
      address,
      city,
      state,
      zipCode,
      comments,
    } = formValues;
    const dataKey = window.ENV.GOOGLE_SHEET_ID;
    const url = `${API_URL}/${window.ENV.TENANT_NAME}/send-email`;
    const requestBody = {
      sender: {
        name: window.ENV.EMAIL.SENDER_NAME,
        email: window.ENV.EMAIL.SENDER_EMAILID,
      },
      to: [
        {
          email: window.ENV.EMAIL.RECEIVER_EMAILID
        },
      ],
      subject: window.ENV.EMAIL.SUBJECT_DOWNLOAD,
      htmlContent: `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
          <title>${window.ENV.EMAIL.SENDER_NAME} | Catalog Downloaded</title>
        </head>
        <body style="margin:0; padding:0; background:#ffffff;">
          <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#ffffff;">
            <tr>
              <td align="center">
                <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width:800px; min-width:320px; background:#ffffff; margin:20px auto 0 auto; border-radius:8px; border:1px solid #ddd;">
                  <tr>
                    <td align="center" bgcolor="${window.ENV.EMAIL.HEADER_COLOR}" style="padding:15px 20px; border-radius:8px 8px 0 0;">
                      <span style="font-size:18px; font-weight:bold; color:#fff; font-family:Arial,sans-serif;">${window.ENV.EMAIL.SENDER_NAME} | Catalog Downloaded</span>
                    </td>
                  </tr>
                  <tr>
                    <td align="left" style="padding:25px; background:#ffffff;">
                      <table width="100%" cellpadding="0" cellspacing="0" border="0">
                        <tr>
                          <td style="padding-bottom:18px;">
                            <span style="font-weight:bold; color:#333; display:inline-block; width:140px; font-family:Arial,sans-serif;">First Name:</span>
                            <span style="color:#333; font-family:Arial,sans-serif;">${firstName}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:18px;">
                            <span style="font-weight:bold; color:#333; display:inline-block; width:140px; font-family:Arial,sans-serif;">Last Name:</span>
                            <span style="color:#333; font-family:Arial,sans-serif;">${lastName}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:18px;">
                            <span style="font-weight:bold; color:#333; display:inline-block; width:140px; font-family:Arial,sans-serif;">Email:</span>
                            <span style="color:#333; font-family:Arial,sans-serif;">${email}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:18px;">
                            <span style="font-weight:bold; color:#333; display:inline-block; width:140px; font-family:Arial,sans-serif;">Phone:</span>
                            <span style="color:#333; font-family:Arial,sans-serif;">${contactNumber}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:18px;">
                            <span style="font-weight:bold; color:#333; display:inline-block; width:140px; font-family:Arial,sans-serif;">Address:</span>
                            <span style="color:#333; font-family:Arial,sans-serif;">${address || 'N/A'}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:18px;">
                            <span style="font-weight:bold; color:#333; display:inline-block; width:140px; font-family:Arial,sans-serif;">City:</span>
                            <span style="color:#333; font-family:Arial,sans-serif;">${city || 'N/A'}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:18px;">
                            <span style="font-weight:bold; color:#333; display:inline-block; width:140px; font-family:Arial,sans-serif;">State:</span>
                            <span style="color:#333; font-family:Arial,sans-serif;">${state || 'N/A'}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:18px;">
                            <span style="font-weight:bold; color:#333; display:inline-block; width:140px; font-family:Arial,sans-serif;">Zip Code:</span>
                            <span style="color:#333; font-family:Arial,sans-serif;">${zipCode || 'N/A'}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:18px;">
                            <span style="font-weight:bold; color:#333; display:inline-block; width:140px; font-family:Arial,sans-serif;">Product:</span>
                            <span style="color:#333; word-break:break-all; font-family:Arial,sans-serif;">${productUrl}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:18px;">
                            <span style="font-weight:bold; color:#333; display:inline-block; width:140px; font-family:Arial,sans-serif;">File Download:</span>
                            <span style="color:#333; word-break:break-all; font-family:Arial,sans-serif;">${selectedOption}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:18px;">
                            <span style="font-weight:bold; color:#333; display:inline-block; width:140px; font-family:Arial,sans-serif;">Comments:</span>
                            <span style="color:#333; font-family:Arial,sans-serif;">${comments || 'N/A'}</span>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </body>
        </html>
      `,
    };
    // Acknowledgement email to sender
    const ackRequestBody = {
      sender: {
        name: window.ENV.EMAIL.SENDER_NAME,
        email: window.ENV.EMAIL.SENDER_EMAILID,
      },
      to: [
        {

          email: email,

        },
      ],
      subject: "Acknowledgement: Your Download Request Received",
      htmlContent: downloadAcknowledgmentHtml,
    };
    try {
      // Send main email
      await axios.post(url, requestBody, {
        headers: {
          "Content-Type": "application/json",
          dataKey: dataKey,
        },
      });
      // Send acknowledgement email
      await axios.post(url, ackRequestBody, {
        headers: {
          "Content-Type": "application/json",
          dataKey: dataKey,
        },
      });
      // Only download PDF after emails sent
      if (selectedOption) {
        const link = document.createElement("a");
        link.href = selectedOption;
        link.target = "_blank";
        link.download = selectedOption?.split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Error submitting form or sending email:", error);
      showSnackbar("An error occurred while sending the email or downloading the file.", 'error');
    }
  };

  // Add at the top, after other useState hooks
  const [snackbarRFQ, setSnackbarRFQ] = useState({ open: false, message: '', severity: 'info' });
  const [pendingRFQ, setPendingRFQ] = useState(null); // { formValues }
  const showSnackbarRFQ = (message, severity = 'info') => {
    setSnackbarRFQ({ open: true, message, severity });
  };
  const handleSnackbarCloseRFQ = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarRFQ({ ...snackbarRFQ, open: false });
    // If there is a pending RFQ, process it now
    if (pendingRFQ && snackbarRFQ.severity === 'success') {
      processRFQAndEmail(pendingRFQ.formValues);
      setPendingRFQ(null);
    }
  };



  // This function is called after the RFQ snackbar closes
  const processRFQAndEmail = async (formValues) => {
    const {
      firstName,
      lastName,
      email,
      contactNumber,
      address,
      city,
      state,
      zipCode,
      comments,
    } = formValues;
    const dataKey = window.ENV.GOOGLE_SHEET_ID;
    const url = `${API_URL}/${window.ENV.TENANT_NAME}/send-email`;
    const requestBody = {
      sender: {
        name: window.ENV.EMAIL.SENDER_NAME,
        email: window.ENV.EMAIL.SENDER_EMAILID,
      },
      to: [
        {

          email: window.ENV.EMAIL.RECEIVER_EMAILID,
        },
      ],
      subject: window.ENV.EMAIL.SUBJECT_RFQ,
      htmlContent: `
        <div style="font-family: Arial, sans-serif; max-width: 800px; margin: 0 auto; background-color: #ffffff; padding: 20px;">
          <!-- Main Box -->
          <div style="background-color: #ffffff; border: 1px solid #ddd; border-radius: 8px; overflow: hidden;">
            <!-- Blue Header Bar -->
            <div style="background-color: ${window.ENV.EMAIL.HEADER_COLOR}; color: white; padding: 15px 20px; text-align: center; font-weight: bold; font-size: 18px;">
              ${window.ENV.EMAIL.SENDER_NAME} | RFQ Request
            </div>
            
            <!-- Content Box -->
            <div style="padding: 25px; background-color: #ffffff;">
              <div style="margin-bottom: 18px;">
                <span style="font-weight: bold; color: #333; display: inline-block; width: 140px;">First Name:</span>
                <span style="color: #333;">${firstName}</span>
              </div>
              <div style="margin-bottom: 18px;">
                <span style="font-weight: bold; color: #333; display: inline-block; width: 140px;">Last Name:</span>
                <span style="color: #333;">${lastName}</span>
              </div>
              <div style="margin-bottom: 18px;">
                <span style="font-weight: bold; color: #333; display: inline-block; width: 140px;">Email:</span>
                <span style="color: #333;">${email}</span>
              </div>
              <div style="margin-bottom: 18px;">
                <span style="font-weight: bold; color: #333; display: inline-block; width: 140px;">Phone:</span>
                <span style="color: #333;">${contactNumber}</span>
              </div>
              <div style="margin-bottom: 18px;">
                <span style="font-weight: bold; color: #333; display: inline-block; width: 140px;">Address:</span>
                <span style="color: #333;">${address || 'N/A'}</span>
              </div>
              <div style="margin-bottom: 18px;">
                <span style="font-weight: bold; color: #333; display: inline-block; width: 140px;">City:</span>
                <span style="color: #333;">${city || 'N/A'}</span>
              </div>
              <div style="margin-bottom: 18px;">
                <span style="font-weight: bold; color: #333; display: inline-block; width: 140px;">State:</span>
                <span style="color: #333;">${state || 'N/A'}</span>
              </div>
              <div style="margin-bottom: 18px;">
                <span style="font-weight: bold; color: #333; display: inline-block; width: 140px;">Zip Code:</span>
                <span style="color: #333;">${zipCode || 'N/A'}</span>
              </div>
              <div style="margin-bottom: 18px;">
                <span style="font-weight: bold; color: #333; display: inline-block; width: 140px;">Product:</span>
                <span style="color: #333; word-break: break-all;">${productUrl}</span>
              </div>
              <div style="margin-bottom: 18px;">
                <span style="font-weight: bold; color: #333; display: inline-block; width: 140px;">File Download:</span>
                <span style="color: #333; word-break: break-all;">${selectedOption}</span>
              </div>
              <div style="margin-bottom: 18px;">
                <span style="font-weight: bold; color: #333; display: inline-block; width: 140px;">Comments:</span>
                <span style="color: #333;">${comments || 'N/A'}</span>
              </div>
            </div>
          </div>
        </div>
      `,
    };
    // Acknowledgement email to sender
    const ackRequestBody = {
      sender: {
        name: window.ENV.EMAIL.SENDER_NAME,
        email: window.ENV.EMAIL.SENDER_EMAILID,
      },
      to: [
        {
          email: email,
        },
      ],
      subject: "Acknowledgement: Your Quote Request Received",
      htmlContent: RFQAcknowledgmentHtml,
    };
    try {
      // Send main email
      await axios.post(url, requestBody, {
        headers: {
          "Content-Type": "application/json",
          dataKey: dataKey,
        },
      });
      // Send acknowledgement email
      await axios.post(url, ackRequestBody, {
        headers: {
          "Content-Type": "application/json",
          dataKey: dataKey,
        },
      });
    } catch (error) {
      console.error("Error submitting RFQ or sending email:", error);
      showSnackbarRFQ("An error occurred while sending the email.", 'error');
    }
  };

  console.log("rertryableimage added");

  return (
    <Mainlayout categoryName={categoryName}>
      <ProductDetailsContainer>
        {error ? (
          <ErrorMessage>{error}</ErrorMessage>
        ) : (
          productData && (
            <DetailsWrapper>
              {/* Left Section */}

              <ImageSection>
                <ImageColumn>
                  <Imagespace>
                    <ReactImageMagnify
                      {...{
                        smallImage: {
                          alt: "Product Image",
                          isFluidWidth: true,
                          src: currentImage,
                          borderRadius: 10,
                        },
                        largeImage: {
                          src: currentImage,
                          width: 1000,
                          height: 1000,
                          borderRadius: 10,
                        },
                        enlargedImageContainerStyle: {
                          borderRadius: 10,
                          zIndex: 9,
                        },
                        enlargedImageStyle: {
                          borderRadius: 10,
                        },
                        imageStyle: {
                          borderRadius: 10,
                        },
                        // isActivatedOnTouch: true,
                      }}
                    />
                  </Imagespace>
                  <Thumbnails className="me-3">
                    {viewTypes.map((view) => {
                      const imageUrl = `${window.ENV.SERVER_URL}${productData[view]}`;
                      return (
                        imageUrl && (
                          // <Thumbnail
                          //   key={view}
                          //   src={imageUrl}
                          //   alt={`${view.replace("_", " ")} Thumbnail`}
                          //   onClick={() => setCurrentImage(imageUrl)}
                          // />
                          <RetryableImage
                            src={imageUrl}
                            alt={`${view.replace("_", " ")} Thumbnail`}
                            onClick={() => setCurrentImage(imageUrl)}
                            maxRetries={window.ENV.MAX_RETRIES || 10}
                            retryDelay={window.ENV.RETRY_DELAY || 5000}
                            style={{
                              width: '72px',
                              height: '72px',
                              cursor: 'pointer',
                              border: window.ENV.GENERAL.PRODUCTDETAIL_IMAGE_BOARDER,
                              borderRadius: '10px',
                              transition: 'border-color 0.2s ease',

                              '&:hover': {
                                borderColor: window.ENV.GENERAL.BACKGROUND_COLOR,
                              },

                              '@media (max-width: 768px)': {
                                width: '70px',
                                height: '70px',
                              },
                            }}
                          />
                        )
                      );
                    })}
                  </Thumbnails>
                </ImageColumn>
              </ImageSection>

              {/* Right Section */}
              <InfoSection>
                <Heading>
                  {productData[window.ENV.PRODUCT_DETAILS_HEADER.LEFT]}:{" "}
                  {productData[window.ENV.PRODUCT_DETAILS_HEADER.RIGHT]}
                </Heading>
                <StyledTable>
                  {/* <h4>{productData.description} : {productData.label}</h4> */}
                  <tbody>
                    {window.ENV.PRODUCT_DETAILS_ITEMS.map((item) => ({
                      label: item.LABEL,
                      value: productData[item.VALUE],
                    }))
                      .filter(
                        ({ value }) =>
                          value !== null && value !== undefined && value !== ""
                      )
                      .slice(0, 8)
                      .map(({ label, value }, idx) => (
                        <StyledRow key={idx}>
                          <StyledCell first>{label}</StyledCell>
                          <StyledCell style={{ width: '5px', textAlign: 'center', fontWeight: 'bold' }}>:&nbsp;</StyledCell>
                          <StyledCell style={{ width: '60%' }}>{value}</StyledCell>
                        </StyledRow>
                      ))}
                  </tbody>
                </StyledTable>
              </InfoSection>
            </DetailsWrapper>
          )
        )}

        {/* Buttons Section */}
        {productData && (
          <ButtonSection>
            <MyButton
              name="View 3D Model"
              onClick={() => handleFileAction(productData["view_3d_model"])}
            />

            <Modal open={open} onClose={handleClose} sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  height: "90%",
                  transform: "translate(-50%, -50%)",
                  width: "100%",

                  maxWidth: 900,
                  bgcolor: "background.paper",
                  borderRadius: 0,
                  boxShadow: 24,
                  padding: "10px",
                  // maxHeight: "90vh",
                  // overflowY: "auto", // Enable scrolling
                }}
              >
                <Typography
                  variant="h5"
                  sx={{ mb: 2, textAlign: "center", position: "relative", fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}
                >
                  {modelPath.includes("mp4") ? "3D Animation" : "3D Model"}
                  <IconButton
                    onClick={handleClose}
                    sx={{
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <hr />
                </Typography>
                {modelPath.includes("mp4") ? (
                  console.log("mp4 block"),
                  <video
                    width="100%"
                    height="90%"
                    controls
                    style={{
                      border: 'none',
                      backgroundColor: 'white',
                      background: 'white'
                    }}
                  >
                    <source src={modelPath} type="video/mp4" />

                  </video>
                ) : (
                  console.log("iframe block"),
                  <iframe
                    src={modelPath}
                    width="100%"
                    height="90%"
                    style={{
                      border: 'none',
                      backgroundColor: 'white',
                      background: 'white'
                    }}
                  />
                )}

              </Box>
              {/* <div
                style={{
                  width: "80vw",
                  height: "80vh",
                  backgroundColor: "#fff",
                  margin: "auto",
                  marginTop: "10vh",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                <Canvas>
                  <ambientLight intensity={0.5} />
                  <directionalLight position={[2, 2, 5]} intensity={1} />
                  {modelPath ? (
                    <OBJModel modelPath={modelPath} />
                  ) : (
                    <p>No model path provided.</p>
                  )}
                  <OrbitControls />
                </Canvas>
              </div> */}
            </Modal>
            <MyButton
              onClick={() => handleFileAction(`${window.ENV.SERVER_URL}${productData["view_2d_drawing"]}`)}
              name="View 2D Sales Drawing"
            />

            {window.ENV.PRODUCT_DETAILS_SHOW_3D_ANIMATION_BUTTON && (
              <MyButton
                onClick={() => handleFileAction(`${window.ENV.SERVER_URL}${productData["view_3d_animation"]}`)}
                name="View 3D Animation"
              />
            )}

            <MySelect
              data={productData}
              type="productDetails"
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              onSelectChange={handleSortOnChange}
            />
            {console.log("Selected Option:", selectedOption, typeof selectedOption)}
            <Tooltip title={selectedOption === "1" ? "Please select an option to download" : ""}>
              <span>
                <MyButton
                  onClick={() => {
                    if (selectedOption !== "1") {
                      handleDownloadModalOpen();
                    }
                  }}
                  name="Download"
                  disabled={!selectedOption || selectedOption === "1"}
                //sx={{ cursor: selectedOption === "1" ? 'not-allowed' : 'pointer' }}
                />
              </span>
            </Tooltip>

            {window.ENV.RFQ_URL && window.ENV.RFQ_URL != null ?
              (<a href={window.ENV.RFQ_URL}
                target="_blank">  <MyButton
                  variant="contained"
                  //color="primary"
                  name="Request Quote"
                //sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}
                /></a>) :
              <MyButton
                variant="contained"
                //color="primary"
                onClick={handleModalOpen}
                name="Request Quote"
              />
            }

            {(window.ENV.FEATURES && window.ENV.FEATURES.SHOW_CART) &&
              <MyButton
                name={isInCart(productData?.productId) ? "Added to Cart" : "Add to Cart"}
                onClick={handleAddToCart}
                //disabled={isInCart(productData?.productId)}
                style={{
                  backgroundColor: window.ENV.BUTTON.BACKGROUND_COLOR,
                  cursor: isInCart(productData?.productId) ? 'not-allowed' : 'pointer',
                  //opacity: isInCart(productData?.productId) ? 0.7 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                {!isInCart(productData?.productId) && <FaShoppingCart size={16} />}
                {isInCart(productData?.productId) ? "Added to Cart" : "Add to Cart"}
              </MyButton>
            }


            <Modal open={openModal} onClose={handleModalClose}>
              <Box sx={ModalBoxStyles}>
                <Typography
                  variant="h5"
                  sx={{
                    mb: 2,
                    textAlign: "center",
                    position: "relative",
                    marginBottom: "4px !important",
                    fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                  }}
                >
                  Request Quote
                  <IconButton
                    onClick={handleModalClose}
                    sx={{
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Typography>
                <hr />
                <Typography
                  variant="body2"
                  sx={{
                    marginBottom: 2,
                    textAlign: "center",
                    color: "text.secondary",
                    fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                  }}
                >
                  If you have any questions, please feel free to email at{" "}
                  <a
                    href={`mailto:${window.ENV.EMAIL.RECEIVER_EMAILID}`}
                    style={{ color: "red" }}
                  >
                    {window.ENV.EMAIL.RECEIVER_EMAILID}
                  </a>
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flex: "1 1 48%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>First Name: <span style={{ color: 'red' }}>
                      {window.ENV.DOWNLOAD_MANDATORY_COLUMNS.includes("firstName") && <>*</>}</span>
                    </InputLabel>
                    <TextField
                      fullWidth
                      name="firstName"
                      value={formValues.firstName}
                      onChange={handleFormChange}
                      required={window.ENV.DOWNLOAD_MANDATORY_COLUMNS.includes("firstName")}
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 48%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Last Name:<span style={{ color: 'red' }}>
                      {window.ENV.DOWNLOAD_MANDATORY_COLUMNS.includes("lastName") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="lastName"
                      value={formValues.lastName}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 48%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Email:<span style={{ color: 'red' }}>
                      {window.ENV.DOWNLOAD_MANDATORY_COLUMNS.includes("email") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="email"
                      value={formValues.email}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 48%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Contact Number:<span style={{ color: 'red' }}>
                      {window.ENV.DOWNLOAD_MANDATORY_COLUMNS.includes("contactNumber") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="contactNumber"
                      value={formValues.contactNumber}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 70%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Address:<span style={{ color: 'red' }}>
                      {window.ENV.DOWNLOAD_MANDATORY_COLUMNS.includes("address") && <>*</>}</span></InputLabel>
                    <textarea
                      name="address"
                      value={formValues.address}
                      onChange={handleFormChange}
                      rows={3} // Number of visible text lines
                      required
                      style={{
                        width: "100%",
                        padding: "0px",
                        fontSize: "14px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        marginTop: "2px",
                      }}
                    ></textarea>
                  </Box>
                  <Box sx={{ flex: "1 1 30%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>City:<span style={{ color: 'red' }} >
                      {window.ENV.DOWNLOAD_MANDATORY_COLUMNS.includes("city") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="city"
                      value={formValues.city}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 30%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>State:<span style={{ color: 'red' }}>
                      {window.ENV.DOWNLOAD_MANDATORY_COLUMNS.includes("state") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="state"
                      value={formValues.state}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 30%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Zip Code:<span style={{ color: 'red' }}>
                      {window.ENV.DOWNLOAD_MANDATORY_COLUMNS.includes("zipCode") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="zipCode"
                      value={formValues.zipCode}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  {/* <Box sx={{ flex: "1 1 100%" }}>
                    <InputLabel>Quantity:</InputLabel>
                    <TextField
                      fullWidth
                      name="quantity"
                      value={formValues.quantity}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "7px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "6px 8px", // Adjust padding inside the input
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 100%" }}>
                    <InputLabel>Requested Delivery:</InputLabel>
                    <TextField
                      fullWidth
                      name="requestedDelivery"
                      value={formValues.requestedDelivery}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "7px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "6px 8px", // Adjust padding inside the input
                        },
                      }}
                    />
                  </Box> */}
                  <Box sx={{ flex: "1 1 100%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Comment:</InputLabel>
                    <textarea
                      name="comments"
                      value={formValues.comments}
                      onChange={handleFormChange}
                      rows={2} // Number of visible text lines
                      required
                      style={{
                        width: "100%",
                        padding: "0px",
                        fontSize: "14px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        marginTop: "2px",
                      }}
                    ></textarea>
                  </Box>
                  <Box sx={{ flex: "1 1 100%" }}>
                    <MyButtonGroup>
                      <MyButton
                        name="Cancel"
                        onClick={handleModalClose}
                      // isRight={true}
                      //sx={{ marginLeft: "5px", marginTop: "2px" }}
                      />
                      <MyButton
                        name="Submit"
                        onClick={handleFormSubmit}
                      // isRight={true}
                      //sx={{ marginLeft: "5px", marginTop: "2px" }}
                      />
                    </MyButtonGroup>
                  </Box>
                </Box>
              </Box>
            </Modal>

            <Modal open={openModalDownload} onClose={handleModalCloseDownload}>
              <Box sx={ModalDownloadBoxStyles}>
                <Typography
                  variant="h5"
                  sx={{
                    mb: 2,
                    textAlign: "center",
                    position: "relative",
                    marginBottom: "4px !important",
                    fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                  }}
                >
                  Download Request
                  <IconButton
                    onClick={handleModalCloseDownload}
                    sx={{
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Typography>
                <hr />
                <Typography
                  variant="body2"
                  sx={{
                    marginBottom: 2,
                    textAlign: "center",
                    color: "text.secondary",
                    fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                  }}
                >
                  If you have any questions, please feel free to email at{" "}
                  <a
                    href={`mailto:${window.ENV.EMAIL.RECEIVER_EMAILID}`}
                    style={{ color: "red" }}
                  >
                    {window.ENV.EMAIL.RECEIVER_EMAILID}

                  </a>
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flex: "1 1 48%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>First Name:<span style={{ color: 'red' }}>
                      {window.ENV.RFQ_MANDATORY_COLUMNS.includes("firstName") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="firstName"
                      value={formValues.firstName}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                        fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 48%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Last Name:<span style={{ color: 'red' }}>
                      {window.ENV.RFQ_MANDATORY_COLUMNS.includes("lastName") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="lastName"
                      value={formValues.lastName}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 48%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Email:<span style={{ color: 'red' }}>
                      {window.ENV.RFQ_MANDATORY_COLUMNS.includes("email") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="email"
                      value={formValues.email}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 48%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Contact Number:<span style={{ color: 'red' }}>
                      {window.ENV.RFQ_MANDATORY_COLUMNS.includes("contactNumber") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="contactNumber"
                      value={formValues.contactNumber}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 70%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Address:<span style={{ color: 'red' }}>
                      {window.ENV.RFQ_MANDATORY_COLUMNS.includes("address") && <>*</>}</span></InputLabel>
                    <textarea
                      name="address"
                      value={formValues.address}
                      onChange={handleFormChange}
                      rows={3} // Number of visible text lines
                      required
                      style={{
                        width: "100%",
                        padding: "0px",
                        fontSize: "14px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        marginTop: "2px",
                      }}
                    ></textarea>
                  </Box>
                  <Box sx={{ flex: "1 1 30%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>City:<span style={{ color: 'red' }}>
                      {window.ENV.RFQ_MANDATORY_COLUMNS.includes("city") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="city"
                      value={formValues.city}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 30%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>State:<span style={{ color: 'red' }}>
                      {window.ENV.RFQ_MANDATORY_COLUMNS.includes("state") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="state"
                      value={formValues.state}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 30%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Zip Code:<span style={{ color: 'red' }}>
                      {window.ENV.RFQ_MANDATORY_COLUMNS.includes("zipCode") && <>*</>}</span></InputLabel>
                    <TextField
                      fullWidth
                      name="zipCode"
                      value={formValues.zipCode}
                      onChange={handleFormChange}
                      required
                      sx={{
                        marginTop: "2px", // Add margin to the TextField
                        "& .MuiInputBase-input": {
                          padding: "4px 8px", // Adjust padding inside the input
                          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: "1 1 100%" }}>
                    <InputLabel sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>Comment:<span style={{ color: 'red' }}>
                      {window.ENV.RFQ_MANDATORY_COLUMNS.includes("comment") && <>*</>}</span></InputLabel>
                    <textarea
                      name="comments"
                      value={formValues.comments}
                      onChange={handleFormChange}
                      rows={2} // Number of visible text lines
                      required
                      style={{
                        width: "100%",
                        padding: "0px",
                        fontSize: "14px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        marginTop: "2px",
                        fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
                      }}
                    ></textarea>
                  </Box>
                  <Box sx={{ flex: "1 1 100%" }}>
                    <MyButtonGroup>
                      <MyButton
                        name="Cancel"
                        onClick={handleModalCloseDownload}
                      // isRight={true}
                      //sx={{ marginLeft: "5px", marginTop: "2px" }}
                      />
                      <MyButton
                        name="Submit"
                        onClick={handleFormSubmitDownload}
                      // isRight={true}
                      //sx={{ marginLeft: "5px", marginTop: "2px" }}
                      />
                    </MyButtonGroup>
                  </Box>
                </Box>
              </Box>
            </Modal>

            {/* <BrochureButton>Product Brochure</BrochureButton> */}
          </ButtonSection>
        )}
        {/* Tabs Section */}
        {productData && (
          <>
            <Box sx={{ borderBottom: 1, borderColor: "divider", marginTop: 4 }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="product details tabs"
                TabIndicatorProps={{
                  style: {
                    background: window.ENV.GENERAL.PRODUCTDETAIL_TAB_BOARDER,
                  },
                }}
                sx={{
                  "& .MuiTabs-indicator": {
                    background: window.ENV.GENERAL.PRODUCTDETAIL_TAB_BOARDER,
                    height: "3px",
                  },
                }}
              >
                <Tab label="Documentation" sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }} />
                {(() => {
                  const detailsData = window.ENV.PRODUCT_DETAILS_ITEMS
                    .map((item) => ({
                      label: item.LABEL,
                      value: productData[item.VALUE],
                    }))
                    .filter(({ value }) => value !== null && value !== undefined && value !== "")
                    .slice(8);
                  return detailsData.length > 5 ? <Tab label="Details" /> : null;
                })()}
              </Tabs>
            </Box>
            {tabValue === 0 && (
              <DocumentationSection>
                <TableWrapper>
                  {/* <Headings>Documentation</Headings> */}
                  <DataTable>
                    <tbody>
                      {docNamesArray.map((name, index) => (
                        <DataRow key={index}>
                          <DataCell>{name.trim()}</DataCell>
                          <DataCell>

                            {/* {docValuesArray[index] ? (
                              <NavLink
                                to={`${window.ENV.SERVER_URL}/pdf/${docValuesArray[
                                  index
                                ].trim()}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "#1e88e5",
                                }}
                              >
                                {docValuesArray[index].trim()}
                              </NavLink>
                            ) : (
                              "N/A"
                            )} */}

                            {
                              docValueText[index] ? (
                                <NavLink
                                  to={`${docValuesArray[index]}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    textDecoration: "none",
                                    color: "#1e88e5",
                                  }}
                                >
                                  {docValueText[index]}
                                </NavLink>
                              ) : (
                                "N/A"
                              )}


                          </DataCell>
                        </DataRow>
                      ))}
                    </tbody>
                  </DataTable>
                </TableWrapper>
              </DocumentationSection>
            )}
            {tabValue === 1 && (
              <DescriptionSection>
                {/* <Headings>Description</Headings> */}
                <DataTable>
                  <tbody>
                    {window.ENV.PRODUCT_DETAILS_ITEMS?.map((item) => ({
                      label: item.LABEL,
                      value: productData[item.VALUE],
                    }))
                      .filter(({ value }) => value !== null && value !== undefined && value !== "")
                      .slice(8)
                      .map(({ label, value }, index) => (
                        <DataRow key={index}>
                          <DataCell>{label}</DataCell>
                          <DataCell>{value}</DataCell>
                        </DataRow>
                      ))}
                  </tbody>
                </DataTable>
              </DescriptionSection>
            )}
          </>
        )}
      </ProductDetailsContainer>

      <Productdetailhr />

      {(typeof window.ENV.SHOW_RELATED_PRODUCT === "undefined" || window.ENV.SHOW_RELATED_PRODUCT) && (
        <RelatedProduct
          relatedItems={relatedItems}
          nextSlide={nextSlide}
          prevSlide={prevSlide}
        />
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{
          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
          "& .MuiSnackbar-root": {
            backgroundColor: window.ENV.BUTTON.BACKGROUND_COLOR,
            color: window.ENV.BUTTON.TEXT_COLOR,
          },
        }}
      >
        <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose} severity={snackbar.severity}
          sx={{
            width: '100%', fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
            backgroundColor: window.ENV.BUTTON.BACKGROUND_COLOR,
            color: window.ENV.BUTTON.TEXT_COLOR,
            "& .MuiAlert-message": {
              fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
              fontSize: "14px",
            },
            "& .MuiAlert-icon": {
              color: window.ENV.BUTTON.TEXT_COLOR,
            },
            "& .MuiAlert-action": {
              color: window.ENV.BUTTON.TEXT_COLOR,
            },
          }}>
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={snackbarRFQ.open}
        autoHideDuration={4000}
        onClose={handleSnackbarCloseRFQ}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}
      >
        <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarCloseRFQ} severity={snackbarRFQ.severity} sx={{ width: '100%', fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>
          {snackbarRFQ.message}
        </MuiAlert>
      </Snackbar>
    </Mainlayout>
  );
};

export default Productdetails;
